<template>
  <div class="active_member d-flex my-1">
    <span class="ml-1" @click="e => $emit('click', e)">
      {{ participantCount }}
      {{
        participantCount > 1
          ? $t("components.messageThread.activeMember.members")
          : $t("components.messageThread.activeMember.member")
      }}
    </span>
    <div class="d-flex align-items-center ml-1" v-if="memberCount > 1">
      <span>&nbsp;-&nbsp;</span>
      <span class="mr-1 active-dot"></span>
      <span>
        {{
          $t("components.messageThread.activeMember.memberActives", {
            memberCount: memberCount
          })
        }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    memberCount: { type: Number, default: 0 },
    participantCount: { type: Number, default: 0 }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";
.active_member {
  font-size: $font-size--x-small;
  color: $color-ui--grey-70;
  font-weight: $font-weight--semi-bold;

  .active-dot {
    width: $size--2;
    height: $size--2;
    background-color: $color-ui--green;
    border-radius: 50%;
    display: inline-block;
    margin-left: $size--2;
    animation: fade-in-out 2s ease-in-out infinite;
  }
}
</style>
